var exports = {
  "lD": "ThreadSidePanel.module__split___Y2phUT",
  "QA": "ThreadSidePanel.module__splitMain___Y2phUT",
  "nd": "ThreadSidePanel.module__panel___Y2phUT",
  "Di": "ThreadSidePanel.module__resizeHandle___Y2phUT",
  "wx": "ThreadSidePanel.module__header___Y2phUT",
  "nr": "ThreadSidePanel.module__headerIcon___Y2phUT",
  "qd": "ThreadSidePanel.module__headerTitle___Y2phUT",
  "$s": "ThreadSidePanel.module__headerActions___Y2phUT",
  "Qs": "ThreadSidePanel.module__content___Y2phUT",
  "rp": "ThreadSidePanel.module__membersPopout___Y2phUT",
  "xm": "ThreadSidePanel.module__membersPopoutList___Y2phUT",
};

module.exports = exports;
